<template>
  <div>
    <FlashMessage v-if="messages.text != ''" :message="messages" />

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] px-10 py-5 mx-auto lg:w-full lg:mr-10 mt-10 pb-20 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <!-- <pre>{{ studentAllList }}</pre> -->
        <div
          class="flex flex-col gap-2 md:flex-row justify-between w-full items-center"
        >
          <div class="flex flex-wrap gap-4 justify-between w-full items-center">
            <div class="">
              <h1 class="text-xl font-semibold text-gray-800">
                Grade Marks
                <span class="ml-2 text-sm font-normal text-gray-500">
                  ({{ studentcount || 0 }})
                </span>

                <span
                  v-if="userSelectList.length > 0"
                  class="ml-3 pl-3 border-l border-gray-200 text-sm font-medium text-indigo-600"
                >
                  Selected: {{ userSelectList.length }}
                </span>
              </h1>
            </div>

            <div class="flex flex-wrap items-center gap-3">
              <button
                @click="openNotes"
                class="px-4 py-1.5 text-sm font-medium rounded-2xl text-white bg-blues hover:bg-blue-600"
              >
                Notes
              </button>

              <div class="">
                <div class="relative w-full md:max-w-80">
                  <div
                    class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4 text-gray-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </div>
                  <input
                    type="text"
                    v-model="searching"
                    @input="getstudentdetails(1)"
                    placeholder="Search..."
                    class="w-full rounded-2xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  />
                  <button
                    v-if="searching"
                    @click="clearSearch"
                    class="absolute inset-y-0 right-0 pr-3 flex items-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4 text-gray-400 hover:text-gray-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </div>
              <button
                class="px-5 py-2 rounded-2xl font-semibold text-sm flex items-center justify-center gap-2 transition-all duration-200"
                @click="handleDownload"
                :disabled="isDownload || userSelectList.length === 0"
                :class="[
                  userSelectList.length > 0
                    ? 'bg-blues hover:bg-blue-700 cursor-pointer text-white '
                    : 'bg-gray-300 cursor-not-allowed text-gray-500 ',
                ]"
              >
                <span v-if="!isDownload" class="flex gap-1 items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                    />
                  </svg>
                  Download
                </span>
                <span v-else class="flex items-center gap-2">
                  <svg
                    class="animate-spin h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                    ></circle>
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8z"
                    ></path>
                  </svg>
                  Download
                </span>
              </button>
            </div>
          </div>
        </div>
        <div class="mt-5">
          <div
            class="w-full bg-[#edf8ff] flex justify-center gap-5 items-center px-2 py-2 mb-4 lg:px-8 rounded-md"
            v-if="response_message"
          >
            <h2 class="text-blues text-center">
              {{ response_message }}
            </h2>
            <router-link
              :to="{ name: 'DownloadHistory' }"
              class="text-blue-600 text-xs underline font-bold"
            >
              Download History
            </router-link>
          </div>
        </div>
        <div
          class="w-full overflow-x-auto rounded-lg border border-gray-200 shadow-sm mt-5"
        >
          <table class="min-w-full divide-y divide-gray-200 text-xs">
            <thead class="bg-gray-50">
              <tr class="divide-x divide-gray-200 whitespace-nowrap">
                <!-- SELECT ALL CHECKBOX -->
                <th class="py-2 px-3 font-semibold text-blues text-left w-10">
                  <input
                    type="checkbox"
                    v-model="selectAll"
                    @change="toggleSelectAll"
                    class="w-4 h-4 rounded text-blue-600 border-gray-400"
                  />
                </th>

                <th class="py-2 px-3 font-semibold text-blues text-center">
                  S NO
                </th>
                <th class="py-2 px-3 font-semibold text-blues text-left">
                  Name
                </th>
                <th class="py-2 px-3 font-semibold text-blues text-left">
                  Participation Mark
                </th>
                <th class="py-2 px-3 font-semibold text-blues text-left">
                  Assignment
                </th>
                <th class="py-2 px-3 font-semibold text-blues text-left">
                  Assessment
                </th>
                <th class="py-2 px-3 font-semibold text-blues text-left">
                  Overall Mark
                </th>
              </tr>
            </thead>

            <tbody v-if="loading" class="h-[300px]">
              <tr>
                <td colspan="6" class="text-center py-8">
                  <div class="flex justify-center items-center">
                    <img src="@/assets/newd/loading.gif" alt="" class="h-10" />
                  </div>
                </td>
              </tr>
            </tbody>

            <tbody
              v-else-if="studentList && studentList.length"
              class="divide-y divide-gray-100 bg-white"
            >
              <tr
                v-for="(el, index) in studentList"
                :key="el.id"
                class="hover:bg-gray-50 transition-colors divide-x divide-gray-100"
              >
                <!-- ROW CHECKBOX -->
                <td
                  class="py-2 px-3 text-left text-gray-500 font-medium whitespace-nowrap"
                >
                  <input
                    type="checkbox"
                    :value="el.id"
                    v-model="userSelectList"
                    class="w-4 h-4 rounded text-blue-600 border-gray-400"
                  />
                </td>

                <td
                  class="py-2 px-3 text-center text-gray-500 font-medium whitespace-nowrap"
                >
                  {{ (currentPage - 1) * pageSize + index + 1 }}
                </td>

                <td class="py-2 px-3 text-left font-medium text-slate-700">
                  <div class="flex flex-col min-w-0">
                    <span
                      class="text-xs font-semibold uppercase text-slate-700"
                    >
                      {{ el?.user?.display_name || "NA" }}
                    </span>
                    <div
                      class="text-[12px] text-gray-500 flex items-center gap-1 break-words"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="12px"
                        viewBox="0 -960 960 960"
                        width="12px"
                        fill="#9CA3AF"
                      >
                        <path
                          d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z"
                        />
                      </svg>
                      {{ el?.user?.email || "NA" }}
                    </div>
                    <div class="text-gray-500 mt-1 text-[10px]">
                      <span class="text-slate-600">PRN: </span>
                      <span class="text-gray-500">{{
                        el?.user?.profile_data?.prn_number ||
                        el?.prn_number ||
                        "NA"
                      }}</span>
                    </div>
                  </div>
                </td>
                <td class="py-2 px-3 text-left font-medium text-gray-600">
                  {{
                    el?.participation_mark != null
                      ? `${el.participation_mark}/5`
                      : "NA"
                  }}
                </td>
                <td class="py-2 px-3 text-left font-medium text-gray-600">
                  {{
                    el?.assignment?.current_mark != null ||
                    el?.percentages?.assignment != null
                      ? `${el.assignment.current_mark ?? "NA"}/${
                          el?.percentages?.assignment ?? "?"
                        }`
                      : "NA"
                  }}
                </td>

                <td class="py-2 px-3 text-left font-medium text-gray-600">
                  {{
                    el?.quize?.current_mark != null ||
                    el?.percentages?.assessment != null
                      ? `${el?.quize?.current_mark ?? "NA"}/${
                          el?.percentages?.assessment ?? "?"
                        }`
                      : "NA"
                  }}
                </td>
                <td class="py-2 px-3 text-left font-medium text-gray-600">
                  {{
                    el?.overall_mark != null || el?.percentages?.total != null
                      ? `${el.overall_mark ?? "NA"}/${
                          el?.percentages?.total ?? "?"
                        }`
                      : "NA"
                  }}
                </td>
              </tr>
            </tbody>

            <tbody v-else>
              <tr>
                <td colspan="6" class="text-center py-8 text-gray-600">
                  No Data Found
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          v-if="studentcount >= 11"
          class="flex flex-col sm:flex-row justify-center gap-3 mt-4 relative"
        >
          <!-- PAGE SIZE -->
          <div
            class="md:absolute md:left-3 md:top-4 gap-2 text-sm text-gray-600 flex justify-center items-center md:flex-none md:justify-normal"
          >
            <span class="flex md:hidden">Rows per page:</span>
            <select
              v-model="pageSize"
              @change="onPageSizeChange"
              class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option :value="10">10</option>
              <option :value="20">20</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
            </select>
          </div>

          <!-- PAGINATION -->
          <div class="flex justify-center">
            <Pagination
              :totalPages="totalPages"
              ref="paginationRef"
              @page-changed="getstudentdetails"
            />
          </div>
        </div>
      </div>

      <!-- Notes Popup -->
      <div
        v-if="showNotesPopup"
        class="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      >
        <div
          class="bg-white rounded-2xl shadow-xl w-[95%] md:w-[80%] lg:w-[50%] max-h-[60vh] flex flex-col"
        >
          <!-- Fixed Header -->
          <div
            class="sticky top-0 z-10 bg-white border-b p-3 flex justify-between items-center rounded-t-2xl"
          >
            <h2 class="text-lg font-semibold">Grade Calculation Notes</h2>

            <button
              @click="closeNotes"
              class="text-gray-500 hover:text-red-500 p-1"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div class="flex-1 overflow-y-auto p-4">
            <!-- Content -->
            <div class="overflow-hidden">
              <div class="space-y-4">
                <!-- Explanation Section -->
                <div>
                  <h3
                    class="text-sm md:text-base font-semibold text-slate-900 mb-1"
                  >
                    1.Assignment Mark Proportional Conversion :
                  </h3>
                  <p class="text-xs md:text-sm text-slate-600 leading-relaxed">
                    The student's assignment marks are converted proportionally
                    to the available grade scale. The assignment score is
                    divided by the total assignment maximum marks and multiplied
                    by the grade scale to determine the final grade mark.
                  </p>
                </div>

                <!-- Formula Box -->
                <div
                  class="bg-indigo-50 border-l-4 border-indigo-500 p-3 rounded-r-lg"
                >
                  <span
                    class="text-xs font-bold uppercase tracking-wider text-indigo-700 block mb-1"
                  >
                    Grade Calculation Formula
                  </span>

                  <code
                    class="text-xs md:text-sm font-mono font-semibold text-indigo-900 block break-words"
                  >
                    Grade Mark = (Student Assignment Marks ÷ Total Assignment
                    Maximum Marks) × Grade Maximum Scale
                  </code>
                </div>
                <div
                  class="bg-indigo-50 border border-indigo-100 rounded-lg p-3"
                >
                  <h4
                    class="text-xs font-bold uppercase tracking-wider text-indigo-700 mb-2"
                  >
                    Total Assignment Maximum Marks Calculation
                  </h4>

                  <div class="space-y-1 text-sm text-indigo-900">
                    <div class="flex justify-between">
                      <span>Number of Assignments</span>
                      <span class="font-semibold">8</span>
                    </div>

                    <div class="flex justify-between">
                      <span>Marks per Assignment</span>
                      <span class="font-semibold">10</span>
                    </div>

                    <div class="border-t border-indigo-200 my-2"></div>

                    <div class="flex justify-between font-semibold">
                      <span>Total Assignment Maximum Marks</span>
                      <span>8 × 10 = 80</span>
                    </div>
                  </div>
                </div>

                <!-- Grid -->
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <!-- Example Inputs -->
                  <div
                    class="bg-slate-50 p-3 rounded-lg border border-slate-100"
                  >
                    <h4
                      class="text-xs font-bold uppercase tracking-wider text-slate-700 mb-3"
                    >
                      Example Values
                    </h4>

                    <ul class="space-y-2 text-sm">
                      <li
                        class="flex justify-between items-center pb-2 border-b border-slate-200/60"
                      >
                        <span class="text-slate-600">
                          Student Assignment Marks
                        </span>

                        <span
                          class="font-mono font-medium text-slate-900 bg-white px-2 py-0.5 rounded border"
                        >
                          68
                        </span>
                      </li>

                      <li
                        class="flex justify-between items-center pb-2 border-b border-slate-200/60"
                      >
                        <span class="text-slate-600">
                          Total Assignment Maximum Marks
                        </span>

                        <span
                          class="font-mono font-medium text-slate-900 bg-white px-2 py-0.5 rounded border"
                        >
                          80
                        </span>
                      </li>

                      <li class="flex justify-between items-center">
                        <span class="text-slate-600">
                          Grade Maximum Scale
                        </span>

                        <span
                          class="font-mono font-medium text-slate-900 bg-white px-2 py-0.5 rounded border"
                        >
                          10
                        </span>
                      </li>
                    </ul>
                  </div>

                  <!-- Calculation -->
                  <div
                    class="bg-emerald-50 p-3 rounded-lg border border-emerald-100 flex flex-col justify-between"
                  >
                    <div>
                      <h4
                        class="text-xs font-bold uppercase tracking-wider text-emerald-700 mb-3"
                      >
                        Calculation Breakdown
                      </h4>

                      <div
                        class="font-mono text-xs md:text-sm text-emerald-800 space-y-1"
                      >
                        <p>Grade Mark = (68 ÷ 80) × 10</p>
                        <p>Grade Mark = 0.85 × 10</p>
                        <p class="font-semibold">Grade Mark = 8.5</p>
                      </div>
                    </div>

                    <div
                      class="mt-3 pt-3 border-t border-emerald-200 flex justify-between items-center"
                    >
                      <span class="text-sm font-medium text-emerald-900">
                        Final Grade Mark
                      </span>

                      <span
                        class="text-lg md:text-2xl font-mono font-bold text-emerald-700"
                      >
                        8.5
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="overflow-hidden mt-2">
              <div class="space-y-4">
                <!-- Explanation Section -->
                <div>
                  <h3
                    class="text-sm md:text-base font-semibold text-slate-900 mb-1"
                  >
                    2.Assessment Mark Proportional Conversion :
                  </h3>

                  <p class="text-xs md:text-sm text-slate-600 leading-relaxed">
                    The student's assessment marks are converted proportionally
                    to the available grade scale. The assessment score is
                    divided by the total assessment maximum marks and multiplied
                    by the grade scale to determine the final grade mark.
                  </p>
                </div>

                <!-- Formula Box -->
                <div
                  class="bg-indigo-50 border-l-4 border-indigo-500 p-3 rounded-r-lg"
                >
                  <span
                    class="text-xs font-bold uppercase tracking-wider text-indigo-700 block mb-1"
                  >
                    Grade Calculation Formula
                  </span>

                  <code
                    class="text-xs md:text-sm font-mono font-semibold text-indigo-900 block break-words"
                  >
                    Grade Mark = (Student Assessment Marks ÷ Total Assessment
                    Maximum Marks) × Grade Maximum Scale
                  </code>
                </div>

                <!-- Total Assessment Maximum Marks -->
                <div
                  class="bg-indigo-50 border border-indigo-100 rounded-lg p-3"
                >
                  <h4
                    class="text-xs font-bold uppercase tracking-wider text-indigo-700 mb-2"
                  >
                    Total Assessment Maximum Marks Calculation
                  </h4>

                  <div class="space-y-1 text-sm text-indigo-900">
                    <div class="flex justify-between">
                      <span>Number of Assessments</span>
                      <span class="font-semibold">5</span>
                    </div>

                    <div class="flex justify-between">
                      <span>Marks per Assessment</span>
                      <span class="font-semibold">20</span>
                    </div>

                    <div class="border-t border-indigo-200 my-2"></div>

                    <div class="flex justify-between font-semibold">
                      <span>Total Assessment Maximum Marks</span>
                      <span>5 × 20 = 100</span>
                    </div>
                  </div>
                </div>

                <!-- Grid -->
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <!-- Example Values -->
                  <div
                    class="bg-slate-50 p-3 rounded-lg border border-slate-100"
                  >
                    <h4
                      class="text-xs font-bold uppercase tracking-wider text-slate-700 mb-3"
                    >
                      Example Values
                    </h4>

                    <ul class="space-y-2 text-sm">
                      <li
                        class="flex justify-between items-center pb-2 border-b border-slate-200/60"
                      >
                        <span class="text-slate-600">
                          Student Assessment Marks
                        </span>

                        <span
                          class="font-mono font-medium text-slate-900 bg-white px-2 py-0.5 rounded border"
                        >
                          85
                        </span>
                      </li>

                      <li
                        class="flex justify-between items-center pb-2 border-b border-slate-200/60"
                      >
                        <span class="text-slate-600">
                          Total Assessment Maximum Marks
                        </span>

                        <span
                          class="font-mono font-medium text-slate-900 bg-white px-2 py-0.5 rounded border"
                        >
                          100
                        </span>
                      </li>

                      <li class="flex justify-between items-center">
                        <span class="text-slate-600">
                          Grade Maximum Scale
                        </span>

                        <span
                          class="font-mono font-medium text-slate-900 bg-white px-2 py-0.5 rounded border"
                        >
                          20
                        </span>
                      </li>
                    </ul>
                  </div>

                  <!-- Calculation -->
                  <div
                    class="bg-emerald-50 p-3 rounded-lg border border-emerald-100 flex flex-col justify-between"
                  >
                    <div>
                      <h4
                        class="text-xs font-bold uppercase tracking-wider text-emerald-700 mb-3"
                      >
                        Calculation Breakdown
                      </h4>

                      <div
                        class="font-mono text-xs md:text-sm text-emerald-800 space-y-1"
                      >
                        <p>Grade Mark = (85 ÷ 100) × 20</p>
                        <p>Grade Mark = 0.85 × 20</p>
                        <p class="font-semibold">Grade Mark = 17</p>
                      </div>
                    </div>

                    <div
                      class="mt-3 pt-3 border-t border-emerald-200 flex justify-between items-center"
                    >
                      <span class="text-sm font-medium text-emerald-900">
                        Final Grade Mark
                      </span>

                      <span
                        class="text-lg md:text-2xl font-mono font-bold text-emerald-700"
                      >
                        17
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/Instructor/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import Pagination from "@/components/Pagination.vue";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: { SideBar, FlashMessage, Pagination },

  props: ["course_id"],

  data() {
    return {
      pageSize: 10,
      studentcount: 0,
      currentPage: 1,
      totalPages: 1,
      response_message: "",
      studentAllList: [],
      studentList: [],
      loading: true,
      searching: "",
      messages: { text: "", type: "null" },
      userSelectList: [],
      selectAll: false,
      isDownload: false,
      showNotesPopup: false,
    };
  },

  created() {
    this.getAllstudentdetails();
    this.getstudentdetails(1);
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  watch: {
    userSelectList() {
      this.selectAll =
        this.userSelectList.length === this.studentAllList.length;
    },
  },

  methods: {
    openNotes() {
      this.showNotesPopup = true;
    },

    closeNotes() {
      this.showNotesPopup = false;
    },
    clearSearch() {
      this.searching = "";
      this.getstudentdetails(1);
    },

    async getAllstudentdetails() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/user-skill/list/?course__id=${this.course_id}&Key=${this.userInfo.token_key}&search=${this.searching}&user__demo_user=false`,
        )
        .then((response) => {
          console.log(response);
          this.studentAllList = response.data?.data || [];
          this.studentcount = response.data?.data?.length;
        });
    },
    async getstudentdetails(page = 1) {
      this.loading = true;
      this.currentPage = page;
      if (!this.pageSize) return;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/user-skill/?course__id=${this.course_id}&Key=${this.userInfo.token_key}&page=${page}&search=${this.searching}&page_size=${this.pageSize}&user__demo_user=false`,
        );

        console.log(response);

        this.totalPages = response.data.total_page || 1;
        this.studentList = response.data?.data || [];
        this.currentPage = response.data.current_page || page;
        this.studentcount = response.data.total;
      } catch (error) {
        console.error("Error fetching student details:", error);
        this.studentList = [];
        this.totalPages = 1;
      } finally {
        setTimeout(() => {
          this.loading = false; // ✅ 1 second delay like assignment
        }, 1000);
      }
    },
    onPageSizeChange() {
      this.currentPage = 1;
      if (this.$refs.paginationRef) {
        this.$refs.paginationRef.currentPage = 1;
      }
      this.getstudentdetails(1);
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.userSelectList = this.studentAllList.map((x) => x.id);
      } else {
        this.userSelectList = [];
      }
    },

    async handleDownload() {
      if (this.isDownload) return;
      this.isDownload = true;
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API}/user-skill/download/?Key=${this.userInfo.token_key}`,
          { object_ids: this.userSelectList },
        );
        if (
          response.status === 202 ||
          response.data.message === "Download started"
        ) {
          this.response_message =
            "Your file is ready to download. Go to the Download History page.";
          setTimeout(() => {
            this.response_message = "";
            this.isDownload = false;
            this.userSelectList = [];
            this.selectAll = false;
          }, 5000);
        } else {
          this.messages = {
            text: "Download failed. Please try again.",
            type: "error",
          };
          setTimeout(() => {
            this.messages = { text: "", type: "null" };
          }, 2500);
          this.isDownload = false;
        }
      } catch (error) {
        this.messages = {
          text: "Something went wrong. Please try again.",
          type: "error",
        };
        setTimeout(() => {
          this.messages = { text: "", type: "null" };
        }, 2500);
        this.isDownload = false;
      }
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
